import React from 'react';

const ChooseCellularPlan = (props) => {

  return (
    <div className='choosing-cellular-plan'>
      <h2 className='title'>מה תרצו לעשות?</h2>
      <div className='plans-wrapper'>
        <button id="niudPlan" disabled={props.isDisable} className={props.phoneType == "transfer" ? 'isSelected' : ''} onClick={() => {props.onClickPhoneType("transfer")}}>ניוד קו</button>
        {props.isShowNewLineBtn && <button id="newPlan" disabled={props.isDisable} className={props.phoneType == "new" ? 'isSelected' : ''} onClick={() => {props.onClickPhoneType("new")}}>קו חדש</button>}
        {props.isShowUpdatePlanTypeBtn &&
        <button id="changePlan" disabled={props.isDisable} className={props.phoneType == "newPlan" ? 'isSelected' : ''}  onClick={() => {props.onClickPhoneType("newPlan")}}>
          <div>כבר מנויים שלנו ורוצים להחליף תוכנית?</div>
          <div className='sub-text'>עברו לתהליך עדכון תוכנית</div>
        </button>
        }
      </div>
    </div>
  );
};

export default ChooseCellularPlan;
